module.exports = __webpack_public_path__ + "static/first-9453dd0a2eb44e8cb4b235483a4f7df8.png";